function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M985.678,5352.807l-.592-2.793a7.859,7.859,0,0,0-4.784-5.742l-1.015-.4a8.746,8.746,0,0,0,1.151-4.4c0-6.506-3.738-7.478-5.966-7.478s-5.966.972-5.966,7.478a8.754,8.754,0,0,0,1.12,4.344l-1.151.451a7.859,7.859,0,0,0-4.784,5.742l-.592,2.793a3.522,3.522,0,0,0,.687,2.94,3.284,3.284,0,0,0,2.573,1.252h16.061a3.285,3.285,0,0,0,2.573-1.252A3.518,3.518,0,0,0,985.678,5352.807ZM974.472,5334c1.713,0,3.989.568,3.989,5.478,0,3.021-1.79,5.478-3.989,5.478s-3.989-2.457-3.989-5.478C970.483,5334.568,972.76,5334,974.472,5334Zm8.982,20.49a1.306,1.306,0,0,1-1.035.51H966.359a1.305,1.305,0,0,1-1.035-.51,1.511,1.511,0,0,1-.292-1.263l.592-2.793a5.872,5.872,0,0,1,3.564-4.3l1.723-.673a4.992,4.992,0,0,0,7.072.044l1.6.629a5.872,5.872,0,0,1,3.565,4.3l.592,2.793A1.511,1.511,0,0,1,983.454,5354.49Z",
  transform: "translate(-963.02 -5332)",
  fill: "#383a3e"
});

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.737,
    height: 25,
    viewBox: "0 0 22.737 25",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.fef2b6c5.svg";
export { ForwardRef as ReactComponent };